/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { rewardNodeProvidersGetApiV3RewardNodeProviders } from "../../funcs/rewardNodeProvidersGetApiV3RewardNodeProviders.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3RewardNodeProvidersRequest$inboundSchema
    .optional(),
};

export const tool$rewardNodeProvidersGetApiV3RewardNodeProviders:
  ToolDefinition<typeof args> = {
    name: "reward-node-providers-get-api-v3-reward-node-providers",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await rewardNodeProvidersGetApiV3RewardNodeProviders(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
